import { createContext, useState} from "react";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [searchData, setSearchData] = useState(null);

  const value = {
    searchData,
    setSearchData
  };
  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};
